// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ContentProvider } from "./context/ContentProvider";
import { ThemeProvider } from "./context/ThemeProvider";
import { BrowserRouter } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <ContentProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ContentProvider>
  </ThemeProvider>
);
